module.exports = __webpack_public_path__ + "img/logo-wide.f5d5d4b9.svg";